import type { Next } from '@wix/funnel-builder-lizard'

import type { Save } from '../../../../../context/StorageContext/StorageContext'
import type { Option } from '../../Content'

type GoSkipParams = {
  options: Option[]
  questionKey: string
  save: Save
  next: Next
}

export const goSkip = (params: GoSkipParams) => {
  const { options, questionKey, save, next } = params

  const builtInOptions = options.filter(option => option.level === 'built-in')
  const appDefIds = builtInOptions.map(option => option.appDefId).filter(i => i) as string[]

  save({ appDefIds })
  next({ [questionKey]: { skipped: true } })
}
